/* istanbul ignore next */
export const pluralize = (value, singular, plural) => value === 1 || (Array.isArray(value) && value?.length === 1)
    ? singular
    : plural;
//# sourceMappingURL=index.js.map